import BliIconSiOpenNew from '@blibli/blue-dls-library-icon/dist/OpenNew'
import { computed } from 'vue'

import { useMainStore } from '@/store/main'

export default {
  components: {
    BliIconSiOpenNew
  },
  setup () {
    const mainStore = useMainStore()

    const isMobile = computed(() => mainStore.isMobile)
    return {
      isMobile
    }
  }
}
